/** Water-quality multi-series chart configs (one graph type id each). */
export const WQ_CHART_CONFIGS = [
  {
    id: "wq-temp-do-bod5",
    title: "Water Temperature, Dissolved Oxygen, BOD5 vs Date",
    series: [
      { key: "WaterTemperature", label: "Water Temperature, °F", color: "#0f766e" },
      { key: "DO", label: "Dissolved Oxygen, mg/L", color: "#1d4ed8" },
      { key: "BOD5", label: "BOD5, mg/L", color: "#b45309" },
    ],
    dualAxis: {
      primaryKeys: ["WaterTemperature"],
      secondaryKeys: ["DO", "BOD5"],
      secondaryRange: [0, 10],
      secondaryStep: 1,
      tickCount: 11,
      primaryTitle: "Water Temperature, °F",
      secondaryTitle: "mg/L",
    },
  },
  {
    id: "wq-bod5-cod",
    title: "BOD5, COD vs Date",
    yAxisTitle: "mg/L",
    series: [
      { key: "BOD5", label: "BOD5, mg/L", color: "#b45309" },
      { key: "COD", label: "COD, mg/L", color: "#7c3aed" },
    ],
  },
  {
    id: "wq-hardness-alkalinity",
    title: "Total Hardness, Alkalinity vs Date",
    yAxisTitle: "mg/L",
    series: [
      { key: "TotalHardness", label: "Total Hardness, mg/L CaCO3", color: "#0369a1" },
      { key: "Alkalinity", label: "Alkalinity, mg/L CaCO3", color: "#15803d" },
    ],
  },
  {
    id: "wq-nitrite-ammonia",
    title: "Nitrite-N, Total Ammonia Nitrogen vs Date",
    yAxisTitle: "mg/L",
    series: [
      { key: "NitriteN", label: "Nitrite-N, mg/L NO2-N", color: "#be185d" },
      { key: "TotalAmmoniaNitrogen", label: "Total Ammonia Nitrogen, mg/L NH3-N", color: "#a16207" },
    ],
  },
  {
    id: "wq-phosphate-phosphorous",
    title: "Phosphate Ion, Phosphorus vs Date",
    yAxisTitle: "mg/L",
    series: [
      { key: "PhosphateIon", label: "Phosphate Ion, mg/L PO4", color: "#0e7490" },
      { key: "Phosphorous", label: "Phosphorus, mg/L P", color: "#c2410c" },
    ],
  },
];

export const WQ_CHART_BY_ID = Object.fromEntries(WQ_CHART_CONFIGS.map((c) => [c.id, c]));

export const GRAPH_TYPES_POND_DETAIL = new Set([
  ...WQ_CHART_CONFIGS.map((c) => c.id),
  "psd-vs-date",
  "population-pct-cumulative-vs-bin",
  "population-cumulative-vs-bin-by-date",
]);

export function isPondDetailGraphType(graphTypeId) {
  return GRAPH_TYPES_POND_DETAIL.has(graphTypeId);
}

export const WQ_GRAPH_TYPE_IDS = new Set(WQ_CHART_CONFIGS.map((c) => c.id));

/** Length-bin graphs (fish + pond cumulative). */
export const GRAPH_TYPES_NEED_BIN_SIZE = new Set([
  "number-frequency",
  "number-frequency-vs-bin",
  "number-frequency-vs-bin-by-date",
  "population-pct-cumulative-vs-bin",
  "population-cumulative-vs-bin-by-date",
]);

/** WQ charts use fixed axis labels; fish/PSD/cumulative use English vs metric. */
export function graphTypeNeedsUnitSystem(graphTypeId) {
  if (!graphTypeId) return false;
  return !WQ_GRAPH_TYPE_IDS.has(graphTypeId);
}

export function graphTypeNeedsBinSize(graphTypeId) {
  if (!graphTypeId) return false;
  return GRAPH_TYPES_NEED_BIN_SIZE.has(graphTypeId);
}
